import CreateDisbursementInfoDialog from "./create-disbursement-info.container";

export default CreateDisbursementInfoDialog;
